import { useState, useEffect} from 'react';

import uiHelpers from '../../../helpers/ui';

import { AssetIcon, CollectionsIcon } from "../../../modules/Icons"
import BannerCard from "./BannerCard"
import OwnedBundleBannerCard from './OwnedBundleBannerCard';

import { BundlesCategoryHeaderProps } from '../../../types/components/bundles/banners/BundlesCategoryHeader';

export const sectionStyles = "relative w-full h-[248px] mb-5 rounded-[5px] bg-cover"
export const gradientOverlay = "absolute inset-0 bg-gradient-to-r from-[#0B1113] to-transparent w-3/4"
export const contentContainer = "relative justify-between items-center z-10 flex h-full px-4 lg:px-[40px] pt-6 pb-6 xl:pt-10 xl:pb-8"

const BundlesCategoryHeader: React.FC<BundlesCategoryHeaderProps> = ({
  category,
}) => {
  if (!category) return;

  const [bannerBackgoundStyles, setBannerBackgroundStyles] = useState({});

  useEffect(() => {
    if (!category) return;
    setBannerBackgroundStyles({
      backgroundImage: uiHelpers.generateBannerBackgroundImageFor(category),
    });
  }, [category]);


  return (
    <section cy-test-id="bundles-category-header" className={sectionStyles} style={bannerBackgoundStyles}>

      <div className={gradientOverlay}></div>

      <div className={contentContainer}>

        <div className="flex flex-col gap-[16px] xl:gap-[24px] items-center lg:items-start justify-center leading-none">
          <div className='text-[28px] xl:text-[36px] font-bold uppercase' cy-test-id="category-name">{category.name}</div>
          <p className='text-[14px] leading-20 xl:text-[16px] text-center lg:text-start font-light lg:max-w-[700px] text-gray-50 xl:leading-24' cy-test-id="cta-text">{category.description}</p>

          <div className="flex gap-2 lg:gap-6 text-[14px] xl:text-[16px]">
            <div className="flex items-center gap-1 font-light text-gray-600">
              <CollectionsIcon />
              <span cy-test-id="total-collections">{category.total_collections} Collections</span>
            </div>

            <div className="flex items-center gap-1 font-light text-gray-600 !fill-gray-900">
              <AssetIcon width="24" height="24" fill="#7F898D"/>
              <span cy-test-id="total-elements">{category.total_elements} Assets</span>
            </div>
          </div>
        </div>

        {
          !category.bundle?.owned ?
            <BannerCard
              bundle={category.bundle}
              backgroundUrl={category.header_image}
            /> :
            <OwnedBundleBannerCard
              bundle={category.bundle}
              backgroundUrl={category.header_image}
            />
        }
      </div>
    </section>
  )
}

export default BundlesCategoryHeader
